import React, { Component, Fragment } from 'react'
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

// services
import { BlockService } from "app/_services/ConfigService/BlockService/BlockService";
import { ProjectService } from "app/_services/ProjectService/ProjectService";

// custom
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import BackBtn from 'app/Components/CommanComponents/BackBtn';
import { formatDDMMYYYYbyYYYYMMDD } from 'app/_helpers/helper';


export class ViewBlock extends Component {
    constructor(props) {
        super(props)

        this.state = {
            // projectId: this.props.match.params.projectId ? this.props.match.params.projectId : "",
            viewId: this.props.match.params.id ? this.props.match.params.id : "",
            // projectData: {},
            viewData: {},
        }
    }

    componentDidMount() {
        // this.setProjectDetails();
        this.viewData();
    }

    /*******************Api Call *******************/
    setProjectDetails = async () => {
        let response = await ProjectService.projectDetailsByID(this.state.projectId);

        if (response && response.status) {
            if (response.data && response.data) {
                this.setState({
                    projectData: response.data
                })
            }
        }
    }

    viewData = async () => {
        let response = await BlockService.getBlockByID(this.state.projectId, this.state.viewId);
        if (response && response.status) {
            if (response.data && response.data) {
                this.setState({
                    viewData: response.data
                })
            }
        }
    }

    render() {
        return (
            <div>
                <MainBreadcrumb
                    routeSegments={[
                        // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
                        // { name: "Configuration", path: "#" },
                        { name: "Global Settings", path: "#" },
                        { name: "Block", path: "/global-configuration/project-details/block" },
                        { name: 'View' }
                    ]}
                    // imageSrc={this.state.projectData.document && Object.keys(this.state.projectData.document).length > 0 ? this.state.projectData.document.document_name : ''}
                    // description={this.state.projectData.descriptionDisplay ? this.state.projectData.descriptionDisplay : ''}
                    breadCrumbsText="Configuration_Project_Details_Block"
                />

                {this.state.viewData && Object.keys(this.state.viewData).length > 0 &&
                    <Fragment>
                        <div className="row d-flex justify-content-center">
                            <div className="col-md-12">
                                <div className="card mt-4 mb-3">
                                    <div className="card-body">
                                        <div className="simple-card-title">
                                            <h3 class="text-capitalize mb-1">View Block</h3>

                                            <BackBtn url="/global-configuration/project-details/block" />
                                        </div>
                                        <div className="addressSmlSec" style={{ paddinTop: '0', borderTop: '0' }}>
                                            <Row>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Country</h5>
                                                    <p>{this.state.viewData.state_master && this.state.viewData.state_master.country_master && this.state.viewData.state_master.country_master.name}</p>
                                                </Col>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>State</h5>
                                                    <p>{this.state.viewData.state_master && this.state.viewData.state_master.name}</p>
                                                </Col>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Block</h5>
                                                    <p>{this.state.viewData.name}</p>
                                                </Col>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>E&P Regime</h5>
                                                    <p>{this.state.viewData.e_p_regime}</p>
                                                </Col>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Agreement Date</h5>
                                                    <p>{this.state.viewData.agreement_date ? formatDDMMYYYYbyYYYYMMDD(this.state.viewData.agreement_date) : ''}</p>
                                                </Col>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Status</h5>
                                                    <p>{this.state.viewData.activeStatus == 1 ? 'Active' : this.state.viewData.activeStatus == 2 ? 'In-Active' : ""}</p>
                                                </Col>
                                                <Col md={12} className="drilingView-bx">

                                                    <div className="row">
                                                        <div className="col-md-12 pt-4">
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered m-0 latlongTable">
                                                                    <thead>

                                                                        <tr>
                                                                            <th scope="col">Coordinate</th>
                                                                            <th scope="col">Latitude</th>
                                                                            <th scope="col">Longitude</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {Array.isArray(this.state.viewData.project_locations) && this.state.viewData.project_locations.length > 0 ?
                                                                            this.state.viewData.project_locations.map((location, index) => {
                                                                                return (
                                                                                    <tr
                                                                                        key={index}
                                                                                    >
                                                                                        <th>#{index + 1}</th>
                                                                                        <td>{location.lattitude ? location.lattitude + "° " + location.lat_dir : ''}</td>
                                                                                        <td>{location.longitude ? location.longitude + "° " + location.long_dir : ''}</td>
                                                                                    </tr>)
                                                                            })
                                                                            : "No Location Found"
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <LogHistory
                            subModulename={'block-master'}
                            projectId={this.state.projectId}
                            refrenceId={this.state.viewId}
                        ></LogHistory>
                    </Fragment>
                }

            </div>
        )
    }
}

export default ViewBlock


